module.exports={PASSPORT:"Passport",NATIONAL_ID_CARD:"National id card"};